import {DataFrame, DataFrameColumnDef, DataFrameRow} from 'data-frames/DataFrameTypes';
import {JSONValue} from 'util/Types';

import findAndAssertColumn from './findAndAssertColumn';
import updateColumnDef from './updateColumnDef';

/**
 * Return a data frame with the specified column transformed using the specified callback function.
 *
 * @param dataFrame Input data frame
 * @param columnSystemName Name of the column to transform
 * @param rowValueTransformFn Callback that defines the transformation. It takes a row and an index and outputs a JSONValue
 * @param columnDefUpdate Optional column definition update. Useful if the transformation changes the type of the column
 */
export default function transformColumn(
  dataFrame: DataFrame,
  columnSystemName: string,
  rowValueTransformFn: (row: DataFrameRow, index: number) => JSONValue,
  columnDefUpdate?: Partial<DataFrameColumnDef>
): DataFrame {
  findAndAssertColumn(dataFrame, columnSystemName);

  const transformedDataFrame = {
    ...dataFrame,
    rows: dataFrame.rows.map((row, index) => ({
      ...row,
      [columnSystemName]: rowValueTransformFn(row, index),
    })),
  };

  return columnDefUpdate == null
    ? transformedDataFrame
    : updateColumnDef(transformedDataFrame, columnSystemName, columnDefUpdate);
}
